<template>
  <div class="content">
    <form>
      <refundsuplier-form :datas="dataall"></refundsuplier-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
  </div>
</template>
<script>
import { RefundsuplierForm, Kontragent, Firma, Sklad, Paytype } from "@/pages";
export default {
  components: {
    RefundsuplierForm,
    Kontragent,
    Firma,
    Sklad,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  created: function() {
    let self=this;
    axios
        .get("api/v1/refund-supplier/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
            self.$store.state.saved=null;
        });
        axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved=null;
        });
  },
  data() {
    return {
      dataall: {
        created_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        updated_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        kontragent_id: 0,
        user_id: parseInt(localStorage.getItem("user_id")),
        pay_type_id: 1,
        price_type: "chakana",
        dollar_rate:0,
        summa: 0,
        // cash_summa: 0,
        // plastic_summa: 0,
        count_all: 0,
        comment: "",
        refund_supplier_table: [
          {
            product_id: 0,
            count: 0,
            price: 0,
            summa: 0,
            price_type:"",
            shtrix_kod: null,
            current_balance: 0
          }
        ]
      }
    };
  }
};
</script>
